import {
  FeatureTogglePort,
  LoggingServicePort,
  PerformanceTrackingPort,
} from '../../shared/ports'
import { startSpan } from '@otto-ec/global-resources/apm'
import type { Span } from '@elastic/apm-rum'
import { allowApmCbLoadTine } from './allow-apm-cb-loadtime'

export class LoadTimeMeasurement {
  static readonly metricNameCbLoadingTime = 'rum_consent_banner_loading_time'
  static readonly metricNameCbInit = 'consent_banner_init'
  static readonly metricNameCbLoaded = 'consent_banner_loaded'
  static readonly metricApmLoadConsentBannerDescription = 'Load consent banner'
  static readonly metricApmLoadConsentBanner = 'module-init.consent-banner.load'

  private span: Span | undefined

  constructor(
    private readonly performanceTrackingService: PerformanceTrackingPort,
    private readonly logger: LoggingServicePort,
    private readonly featureTogglesPort: FeatureTogglePort
  ) {}

  async startLoadTimeMeasurement() {
    this.performanceTrackingService.markPerformanceMetric(
      LoadTimeMeasurement.metricNameCbInit
    )
    this.span = await this.startApmSpan(
      LoadTimeMeasurement.metricApmLoadConsentBannerDescription,
      LoadTimeMeasurement.metricApmLoadConsentBanner,
      false
    )
  }

  finishLoadTimeMeasurement() {
    this.performanceTrackingService.markPerformanceMetric(
      LoadTimeMeasurement.metricNameCbLoaded
    )
    this.performanceTrackingService.sendMeasurement(
      LoadTimeMeasurement.metricNameCbInit,
      LoadTimeMeasurement.metricNameCbLoaded,
      LoadTimeMeasurement.metricNameCbLoadingTime
    )
    this.endApmSpan(this.span)
  }

  private endApmSpan(span?: Span): void {
    if (allowApmCbLoadTine(this.featureTogglesPort)) {
      try {
        span?.end()
      } catch (error) {
        this.logger.error(
          new Error(
            `Could not end span for measuring apm consent-banner.load metric`,
            { cause: error }
          )
        )
      }
    }
  }

  private async startApmSpan(
    name: string,
    type: string,
    isBlocking: boolean
  ): Promise<Span | undefined> {
    if (allowApmCbLoadTine(this.featureTogglesPort)) {
      try {
        return await startSpan(name, type, { blocking: isBlocking })
      } catch {
        return undefined
      }
    } else return undefined
  }
}
